/*
 * @Author: gang.liu
 * @Date: 2021-06-28 09:21:02
 * @LastEditTime: 2021-06-29 14:14:18
 * @LastEditors: gang.liu
 * @Description:
 * @api-property:
 * @api-event:
 * @api-method:
 */

/**
 * 首页
 * @type {{path: string, meta: {ignores: string[], title: string}, name: string}}
 */
export const homeRoute = {
  name: "home",
  path: "/",
  meta: {
    title: "归源易生",
    ignores: ["home"],
  },
};

/**
 * 注册
 * @type {{path: string, meta: {ignores: string[], title: string}, name: string}}
 */
export const registerRoute = {
  name: "register",
  path: "/register",
  meta: {
    title: "注册",
    ignores: ["register"],
  },
};

/**
 * 注册
 * @type {{path: string, meta: {ignores: string[], title: string}, name: string}}
 */
export const retrievePasswordRoute = {
  name: "retrievePassword",
  path: "/retrievePassword",
  meta: {
    title: "注册",
    ignores: ["register"],
  },
};

/**
 * 登录
 * @type {{path: string, meta: {ignores: string[], title: string}, name: string}}
 */
export const loginRoute = {
  name: "login",
  path: "/login",
  meta: {
    title: "注册",
    ignores: ["login"],
  },
};

/**
 * 行业咨询
 */
export const consultativeRoute = {
  name: "consultative",
  path: "/consultative",
  meta: {
    title: "行业咨询",
    ignores: ["consultative"],
  },
};

/**
 * 用户注册协议
 */
export const protocolRoute = {
  name: "protocol",
  path: "protocol",
  meta: {
    title: "用户注册协议",
  },
};

/**
 * 免责声明
 */
export const disclaimerRoute = {
  name: "disclaimer",
  path: "disclaimer",
  meta: {
    title: "免责声明",
  },
};

/**
 * 最终用户使用协议
 */
export const agreementRoute = {
  name: "agreement",
  path: "agreement",
  meta: {
    title: "最终用户使用协议",
  },
};

/**
 * 实训课堂
 */
export const chineseMedicineRoute = {
  name: "chineseMedicine",
  path: "chineseMedicine",
  meta: {
    title: "实训课堂",
  },
};

/**
 * 实训课堂详情
 */
export const chineseMedicineDetailsRoute = {
  name: "chineseMedicineDetails",
  path: "chineseMedicineDetails",
  meta: {
    title: "实训课堂详情",
  },
};

/**
 * 联系我们
 */
export const contactUsRoute = {
  name: "contactUs",
  path: "contactUs",
  meta: {
    title: "联系我们",
  },
};

/**
 * 联系我们
 */
export const partnersRoute = {
  name: "partners",
  path: "partners",
  meta: {
    title: "合作伙伴",
  },
};

/**
 * 药品信息 - 一级列表页
 */
export const medicineInfoRoute = {
  name: "medicineInfo",
  path: "/medicineInfo",
  meta: {
    title: "药品信息",
    ignores: ["medicineInfo"],
  },
};

/**
 * 药品详情 - 二级详情页
 */
export const medicineDetailRoute = {
  name: "medicineDetail",
  path: "/medicineDetail",
  meta: {
    title: "药品详情",
    ignores: ["medicineDetail"],
  },
};
